import { facet1 } from './facet-1.styles'
import { facet2 } from './facet-2.styles'
import { facet3 } from './facet-3.styles'
import { facet4 } from './facet-4.styles'
import { facet5 } from './facet-5.styles'
import { facet6 } from './facet-6.styles'
import { facet7 } from './facet-7.styles'
import { facet8 } from './facet-8.styles'
import { facet9 } from './facet-9.styles'
import { facet10 } from './facet-10.styles'
import { facet1OnDarkStyles } from './facet-1--onDark.styles'
import { facet2OnDarkStyles } from './facet-2--onDark.styles'

export const allStyles = [facet1, facet2, facet3, facet4, facet5, facet6, facet7, facet8, facet9 , facet10];
export const allFacetsOnDarkStyles = [facet1OnDarkStyles, facet2OnDarkStyles];